import { render, staticRenderFns } from "./MenuNew.vue?vue&type=template&id=3af2a482&scoped=true&"
import script from "./MenuNew.vue?vue&type=script&lang=js&"
export * from "./MenuNew.vue?vue&type=script&lang=js&"
import style0 from "./MenuNew.vue?vue&type=style&index=0&id=3af2a482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af2a482",
  null
  
)

export default component.exports